export default "__VITE_ASSET__B3Jtw25W__"